import { AdvancedMarker, APIProvider, Map, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const mapId = process.env.REACT_APP_GOOGLE_MAP_ID;

function UrbanMarker() {
  return (
    <div className="urban-map-marker" data-testid="urban-map-marker">
      <span />
    </div>
  );
}

function ManagedMap({ address, latitude, longitude }) {
  const geocodingLibrary = useMapsLibrary("geocoding");
  const [center, setCenter] = useState({ lat: latitude, lng: longitude });

  useEffect(() => {
    setCenter({ lat: latitude, lng: longitude });
  }, [latitude, longitude]);

  useEffect(() => {
    if (!address || !geocodingLibrary) return;
    const geocoder = new geocodingLibrary.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status !== "OK" || !results?.[0]?.geometry?.location) return;
      const location = results[0].geometry.location;
      setCenter({ lat: location.lat(), lng: location.lng() });
    });
  }, [address, geocodingLibrary]);

  return (
    <Map
      center={center}
      colorScheme="DARK"
      defaultZoom={14}
      disableDefaultUI
      fullscreenControl
      gestureHandling="cooperative"
      heading={0}
      mapId={mapId}
      mapTypeControl={false}
      rotateControl={false}
      streetViewControl={false}
      tilt={0}
      zoomControl
    >
      <AdvancedMarker position={center} title="Urban Motors"><UrbanMarker /></AdvancedMarker>
    </Map>
  );
}

export default function UrbanMap({ address, latitude, longitude, testId }) {
  if (!apiKey || !mapId) {
    return <div className="map-unavailable" data-testid={`${testId}-unavailable`}>Kartkonfigurasjon mangler.</div>;
  }

  return (
    <APIProvider apiKey={apiKey} libraries={["geocoding"]}>
      <ManagedMap address={address} latitude={latitude} longitude={longitude} />
    </APIProvider>
  );
}